import React from "react";
import MapComponent from "./MapComponent";
import Form from "./Form";
import { AiFillHome, AiFillPhone } from "react-icons/ai";
import { BsEnvelopeFill } from "react-icons/bs";
import { IoLogoWhatsapp } from "react-icons/io";

const Contact = () => {
  const contactmedia = [
    {
      id: 1,
      icon: <AiFillHome />,
      title: "Office Address",
      field:
        "Toye Building, No 74, Ogunnusi Road, Suite: 213, First floor, Beside FRSC Office, Ojodu-Berger, Ikeja, Lagos",
    },
    {
      id: 2,
      icon: <AiFillPhone />,
      title: "Phone Number",
      field: "0706 654 1117",
    },
    {
      id: 3,
      icon: <BsEnvelopeFill />,
      title: "Email",
      field: "revpointsolutions@gmail.com,  info@revpointsolutions.com",
    },
    {
      id: 4,
      icon: <IoLogoWhatsapp />,
      title: "Whatsapp Number",
      field: "+234 808 4344 424",
    },
  ];
  return (
    <>
      <section id="contact" className="w-full py-10 mt-10 container mx-auto">
        <div className="mx-auto flex flex-col gap-10 lg:flex-row lg:justify-between lg:pl-0">
          <div className="flex flex-col space-y-5 w-11/12 mx-auto lg:w-1/2 ">
            <p className="text-2xl md:text-4xl font-semibold text-darkBlue text-opacity-75">
              Get in touch with us!
            </p>
            <p className="text-md lg:text-lg text-darkBlue opacity-80">
              You can get in touch with us through any of the meduim below,
              Including through the form provided
            </p>
            <div className="flex flex-col space-y-10">
              {contactmedia.map((contact) => (
                <>
                  <div key={contact.id} className="flex items-center space-x-4">
                    <div className="w-20 h-20 bg-black rounded-lg flex justify-center items-center bg-opacity-[0.5]">
                      <p className="text-4xl text-white">{contact.icon}</p>
                    </div>
                    <div className="flex flex-col space-y-1 w-8/12">
                      <p className="text-xl font-medium text-darkBlue opacity-80">
                        {contact.title}
                      </p>
                      <p className="text-darkBlue opacity-75">
                        {contact.field}
                      </p>
                    </div>
                  </div>
                </>
              ))}
            </div>
          </div>
          <Form />
        </div>
      </section>
    </>
  );
};

export default Contact;
